export default function RecipeSteps({ steps }) {
	// console.log('steps :>> ', steps)
	function chunksToHTML(chunks) {
		const jsxArray = chunks.map(chunk => {
			if (chunk.type === 'ingredient') {
				return `<span class="ingredient">${chunk.name}</span>`
			}
			if (chunk.type === 'timer') {
				return `<span class="timer">${chunk.quantity} ${chunk.units}</span>`
			}
			if (chunk.type === 'cookware') {
				return `<span class="cookware">${chunk.name}</span>`
			}
			return `<span>${chunk.value}</span>`
		})
		return jsxArray.join('')
	}

	return (
		<ol className="recipe-steps max-w-prose px-4 leading-8 md:pl-14 md:pt-0 md:text-lg">
			{steps.map((step, i) => (
				<li key={i} className="relative before:mx-auto before:sm:mx-0 md:pb-6">
					<p
						className="max-w-prose py-6 leading-relaxed md:py-0 md:pl-4"
						dangerouslySetInnerHTML={{ __html: chunksToHTML(step) }}
					></p>
				</li>
			))}
		</ol>
	)
}
